import { ArrowUpRight } from 'lucide-react';
import { describeAskDestination } from './askDestination';
import { journey } from '../search/useDiscoverySearch';

export const AskReferences = ({ references = [], id, onNavigate }) => {
  const seen = new Set();
  const reports = (Array.isArray(references) ? references : []).filter(ref => {
    const prefix = ref?.entity_type === 'company' ? '/company/' : ref?.entity_type === 'asset' ? '/asset/' : null;
    if (!prefix || !ref.label || !ref.url?.startsWith(prefix) || !/^\/(company|asset)\/[^/\\?#]+$/.test(ref.url) || seen.has(ref.url)) return false;
    seen.add(ref.url);
    return true;
  });
  if (!reports.length) return null;
  return <section className="ask-references" aria-labelledby={`ask-references-heading-${id}`} data-testid={`ask-references-${id}`}>
    <h2 id={`ask-references-heading-${id}`} data-testid={`ask-references-heading-${id}`}>Referenced reports</h2>
    <div className="ask-reference-list" data-testid={`ask-reference-list-${id}`}>
      {reports.map((ref, index) => {
        const destination = describeAskDestination({ url: ref.url }, { subject: { label: ref.label, entity_type: ref.entity_type } });
        const { Icon } = destination;
        const title = destination.title + (ref.coverage_state === 'limited' ? ' · Limited coverage' : '');
        return <a key={ref.url} href={ref.url} className="ask-reference-chip" data-testid={`ask-reference-${id}-${index}`}
          aria-label={title} title={title} onClick={event => {
            journey('report_opened', { category: ref.entity_type });
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            onNavigate(ref.url, destination);
          }}>
          <Icon size={14} aria-hidden="true" />
          <span data-testid={`ask-reference-label-${id}-${index}`}>{ref.label}</span>
          {ref.coverage_state === 'limited' && <small data-testid={`ask-reference-coverage-${id}-${index}`}>Limited</small>}
          <ArrowUpRight size={13} aria-hidden="true" />
        </a>;
      })}
    </div>
  </section>;
};